// src/components/WhoWeAre.js
import React from 'react';

const OurStory = () => {
    return (
        <section className="px-4 py-5 bg-white">
            <p className="text-red-600 font-bold mb-2 flex items-center justify-center gap-2">
                <span className="w-3 h-3 bg-theme-color rounded-full inline-block"></span>Who We Are
            </p>
            <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold mb-1 text-center">
                The Intersection of Vision and Expertise.
            </h2>
            <div className="max-w-screen-xl mx-auto flex flex-col lg:flex-row items-center gap-2">
                <div className="lg:w-1/2 mt-10 lg:mt-0 text-center">
                    <img
                        src="/images/home/ourstory-bg.png"
                        alt="SM6 Corp Design"
                        className="max-w-full h-160"
                    />
                </div>
                <div className="lg:w-1/2 text-center lg:text-left space-y-2">
                    <p className="text-lg text-gray-600">
                        SM6 Corp is a young team of multi-award-winning architects based in Bangalore, India.
                    </p>
                    <p className="text-lg text-gray-600">
                        We place human experience at the centre of our design process to deliver 
                        engaging, future-oriented projects that respond to how people actually 
                        use space.
                    </p>
                    <p className="text-lg text-gray-600">
                       SM6 Corp approaches each development as a boutique, customised to a high 
                       degree. Each site we design has its own inherent qualities, and whether 
                       it is a large, medium, or small-scale development, sustainability is at 
                       the forefront of our minds. The efficient use of space and materials is 
                       paramount.
                    </p>
                </div>
            </div>
        </section>
    );
};

export default OurStory;
